import React, { Fragment } from 'react';
import { Box, Typography } from '@vp/swan';
import { useProductContext } from 'src/hooks/ProductContextHooks';
import { text } from 'src/utils/localizationUtil';
import {
  getTranslatedNameForProductOptionKey,
  getTranslatedNameForProductOptionValue,
} from 'src/utils/productOptionUtils';
import { Price, PriceDisplay } from './PriceDisplay';

export interface ProductOptionSelectionDisplayProps {
  isOriginal: boolean;
  selections: { [name: string]: string };
  optionsToDisplay: string[];
  isMobile: boolean;
  price: Price | null;
}

export const ProductOptionSelectionDisplay = ({
  isOriginal,
  selections,
  optionsToDisplay,
  price,
}: ProductOptionSelectionDisplayProps): JSX.Element => {
  const { productOptionTranslations } = useProductContext();

  return (
    <Box style={{ textAlign: 'center', width: '45%' }}>
      <Typography textAlign="center" fontSize={'standard'} marginBottom={'5'} fontWeight="bold">
        {isOriginal
          ? text('product-option-suggestion.original-selection-title')
          : text('product-option-suggestion.suggested-selection-title')}
      </Typography>
      <Typography textAlign="center" fontSize={'x2large'} marginBottom={'5'} fontWeight="bold">
        {price && <PriceDisplay multiLine price={price} priceIsLoaded />}
      </Typography>
      {optionsToDisplay.map(
        optionKey =>
          selections[optionKey] && (
            <Fragment key={optionKey}>
              <Typography textAlign="center" fontSize={'large'} fontWeight="bold">
                {getTranslatedNameForProductOptionKey(productOptionTranslations, optionKey)}
              </Typography>
              <Typography textAlign="center" fontSize={'standard'}>
                {getTranslatedNameForProductOptionValue(productOptionTranslations, optionKey, selections[optionKey])}
              </Typography>
            </Fragment>
          )
      )}
    </Box>
  );
};
